import React from "react";
import "./NewBadge.css";

export default function NewBadge({ label = "Шинэ" }) {
  return <span className="attention-new-badge">{label}</span>;
}
